import KitUploadedFiles from './KitUploadedFiles';

export default KitUploadedFiles;
